'use strict';
// @flow

import { combineReducers } from 'redux-immutable';

import filtro from './filtro';

export default combineReducers({ filtro });
